<template>
  <section class="mail-card">
    <h2>{{ tt("general.general_info", "Genel Bilgiler") }}</h2>
    <div class="mail-field-grid">
      <div>
        <label>{{ tt("general.mail_type", "Mail Türü") }}</label>
        <div class="mail-select-wrap">
          <app-multiselect v-model="mailType"
                           :close-on-select="true"
                           :hide-label="true"
                           :is-searchable="false"
                           :options="mailTypeOptions"
          />
        </div>
      </div>
      <div>
        <label for="mail-template-subject">{{
            tt("mail.subject", $t("general.heading"))
          }}</label>
        <input id="mail-template-subject"
               :class="{ 'is-invalid': subjectError }"
               :placeholder="tt('mail.subject', $t('general.heading'))"
               :value="subject"
               class="mail-input"
               maxlength="255"
               type="text"
               @input="onSubjectInput"
        />
        <p v-if="subjectError" class="mail-field-error">
          {{ subjectError }}
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import AppMultiselect from "@/view/components/select/app-multiselect/app-multiselect.vue";

export default {
  name: "MailTemplateGeneralInfo",
  components: { AppMultiselect },
  props: {
    mailTypeOptions: {
      type: Array,
      default() {
        return [];
      },
    },
    selectedMailType: {
      type: Object,
      default: null,
    },
    subject: {
      type: String,
      default: "",
    },
    subjectError: {
      type: String,
      default: "",
    },
  },
  computed: {
    mailType: {
      get() {
        return this.selectedMailType;
      },
      set(value) {
        this.$emit("update:selectedMailType", value);
      },
    },
  },
  methods: {
    tt(key, fallback) {
      if (this.$te && this.$te(key)) {
        const translated = this.$t(key);
        if (translated && translated !== key) return translated;
      }
      return fallback;
    },
    onSubjectInput(event) {
      this.$emit("update:subject", event.target.value);
      this.$emit("clear-subject-error");
    },
  },
};
</script>

<style scoped>
.mail-card {
  background: #fff;
  border: 1px solid var(--mail-border);
  border-radius: 12px;
  padding: 20px 24px 24px;
}

.mail-card h2 {
  margin: 0 0 16px;
  color: var(--mail-text);
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.mail-field-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.mail-field-grid label {
  display: block;
  margin-bottom: 8px;
  color: var(--mail-label);
  font-size: 13px;
  font-weight: 600;
}

.mail-input {
  width: 100%;
  height: 40px;
  padding: 8px 14px;
  border: 1px solid var(--mail-input-border);
  border-radius: 8px;
  background: #fff;
  color: #5c6180;
  font-size: 14px;
}

.mail-input:focus {
  outline: none;
  border-color: var(--mail-primary);
  box-shadow: 0 0 0 3px rgba(91, 79, 255, 0.08);
}

.mail-input.is-invalid {
  border-color: #e31748;
}

.mail-select-wrap ::v-deep h5 {
  display: none;
}

.mail-select-wrap ::v-deep .multiselect {
  min-height: 40px;
}

.mail-select-wrap ::v-deep .multiselect--active {
  z-index: 20;
}

.mail-select-wrap ::v-deep .multiselect__tags {
  display: flex;
  align-items: center;
  min-height: 40px;
  height: 40px;
  padding: 0 36px 0 14px;
  border: 1px solid var(--mail-input-border);
  border-radius: 8px;
  background: #fff;
}

.mail-select-wrap ::v-deep .multiselect__single {
  margin: 0;
  padding: 0;
  overflow: hidden;
  color: #5c6180;
  font-size: 14px;
  line-height: 24px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mail-select-wrap ::v-deep .multiselect__select {
  width: 36px;
  height: 40px;
  transform: none;
}

.mail-select-wrap ::v-deep .multiselect--active .multiselect__select {
  transform: none;
}

.mail-select-wrap ::v-deep .multiselect__select::before {
  top: 16px;
  margin-top: 0;
  border-width: 5px 5px 0;
  border-color: var(--mail-primary) transparent transparent;
  transform: none;
  transition: transform 0.15s ease;
}

.mail-select-wrap ::v-deep .multiselect--active .multiselect__select::before {
  border-width: 5px 5px 0;
  border-color: var(--mail-primary) transparent transparent;
  transform: rotate(180deg);
}

.mail-select-wrap ::v-deep .multiselect__content-wrapper {
  border: 1px solid var(--mail-border);
  border-radius: 8px;
  box-shadow: 0 10px 24px rgba(23, 26, 47, 0.08);
  margin-top: 4px;
}

.mail-select-wrap ::v-deep .multiselect__option {
  font-size: 14px;
  color: #2a2f4a;
  padding: 10px 14px;
}

.mail-select-wrap ::v-deep .multiselect__option--highlight {
  background: #f4f2ff;
  color: var(--mail-primary);
}

.mail-select-wrap ::v-deep .multiselect__option--selected {
  font-weight: 600;
  background: #fff;
  color: var(--mail-primary);
}

.mail-field-error {
  margin: 8px 0 0;
  color: #e31748;
  font-size: 12px;
}

@media (max-width: 767px) {
  .mail-field-grid {
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  .mail-input {
    width: 100%;
  }

  .mail-card {
    padding: 18px;
  }
}
</style>
